import React, { useEffect, useRef, useState } from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import NoImageFoundDocument from "./noImageFoundDocument";

export default function UnionLoadDocument(props: any) {
  const images = props.data;
  const spanRef = useRef<HTMLSpanElement>(null);
  const [textWidth, setTextWidth] = useState(0);
  const [widthDiv, setWidthDiv] = useState<any>(0);

  // let isValue = false;
  // if (props.title! == true && props.data) {
  //     isValue = true
  // } else if (props.title! == false && props.data) {
  //     isValue = false
  // }
  const getTextWidthInPixels = (ref: HTMLSpanElement) =>
    ref.getBoundingClientRect().width;

  useEffect(() => {
    setTextWidth(getTextWidthInPixels(spanRef.current!));
  }, [spanRef]);

  let classText: any;
  if (textWidth > widthDiv) {
    classText = "paraghramImageUnion infoText";
  }

  const reference = React.useRef(null);
  const [dimensions, setDimensions] = useState<any>({ width: 0, height: 0 });
  useEffect(() => {
    if (reference.current) {
      setDimensions({
        width: reference?.current,
        height: reference.current,
      });
    }
    setWidthDiv(dimensions.width.offsetWidth);
  });

  const handleOpenImage = (image: string) => {
    const imageUrl = image!;

    if (!imageUrl) {
      alert("آدرس تصویر وجود ندارد.");
      return;
    }

    const newWindow = window.open("", "_blank");
    if (!newWindow) {
      alert("پنجره جدید توسط مرورگر مسدود شده است.");
      return;
    }

    const htmlContent = `
    <!DOCTYPE html>
    <html lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>نمایش تصویر</title>
      <style>
      @font-face {
      font-family: "iranSansMedium";
      src: url("/fonts/IRANSansBold.ttf");
      }
      html, body {
      height: 100%;
      margin: 0;
      padding: 0;
      }
      body {
      background-color: #fff;
      margin: 0;
      font-family: "iranSansMedium";
      min-height: 100vh;
      min-width: 100vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      }
      .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 20vh;
      flex: 1;
      overflow: hidden;
      }
      img {
      max-width: 90vw;
      max-height: 80vh;
      min-width: 40%;
      min-height: 40%;
      transition: transform 0.3s ease, width 0.3s, height 0.3s;
      border: 1px solid #ddd;
      display: block;
      margin: 0 auto;
      object-fit: contain;
      cursor: default;
      }
      img.zoom-cursor {
      cursor: zoom-in;
      }
      img.zoomed {
      cursor: zoom-out;
      z-index: 10;
      }
      .buttons {
      margin-top: 20px;
      position: static;
      text-align: center;
      }
      button {
      height: 5vh;
      background-color: #3498db;
      color: white;
      border: none;
      padding: 7px 20px;
      margin: 0 10px;
      font-size: 15px;
      cursor: pointer;
      border-radius: 5px;
      font-family: "iranSansMedium";
      display: inline-flex;
      align-items: center;
      gap: 5px;
      }
      button .icon {
      font-family: "iranSansMedium";
      font-size: 1.3rem;
      vertical-align: middle;
      position: relative;
      top: 3px;
      }
      button:hover {
      background-color: #2980b9;
      }
      </style>
    </head>
    <body>
      <div class="image-container">
      <img id="rotatableImage" src="${imageUrl}" alt="تصویر" />
      </div>
      <div class="buttons">
      <button onclick="rotate(-90)"><span class="icon">⟲</span> چرخش به چپ</button>
      <button onclick="rotate(90)">چرخش به راست <span class="icon">⟳</span></button>
      </div>
      <script>
      let angle = 0;
      let scale = 1;
      function rotate(deg) {
      angle = (angle + deg) % 360;
      updateTransform();
      // Adaptive resizing for 90/270 degrees
      const img = document.getElementById("rotatableImage");
      if (Math.abs(angle % 180) === 90) {
        img.style.maxWidth = "80vh";
        img.style.maxHeight = "90vw";
      } else {
        img.style.maxWidth = "90vw";
        img.style.maxHeight = "80vh";
      }
      }
      function updateTransform() {
      const img = document.getElementById("rotatableImage");
      img.style.transform = "rotate(" + angle + "deg) scale(" + scale + ")";
      }
      // Initial resize in case image is already rotated
      rotate(0);

      // Zoom on hover/click
      const img = document.getElementById("rotatableImage");
      img.classList.add('zoom-cursor');
      let zoomed = false;
      img.addEventListener('mouseenter', function() {
      img.classList.add('zoom-cursor');
      });
      img.addEventListener('mouseleave', function() {
      img.classList.remove('zoom-cursor');
      img.classList.remove('zoomed');
      scale = 1;
      updateTransform();
      zoomed = false;
      });
      img.addEventListener('click', function() {
      zoomed = !zoomed;
      if (zoomed) {
        scale = 2;
        img.classList.add('zoomed');
      } else {
        scale = 1;
        img.classList.remove('zoomed');
      }
      updateTransform();
      });
      </script>
    </body>
    </html>
    `;

    newWindow.document.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };
  return (
    <>
      {images[0] != null ? (
        <div className="UploadImageCmp" style={{ direction: "ltr" }}>
          <>
            {/* <a href={props.data.fileUrl!} target="_blank"> */}
            <Carousel showThumbs={false} showStatus={false} infiniteLoop={true}>
              {images?.map((image: any) =>
                image != undefined && image != null ? (
                  <>
                    <a
                      onClick={() => handleOpenImage(`${image.fileUrl}/true`)}
                      href={`${image.fileUrl}/true`}
                      target="blank"
                      style={{
                        maxWidth: "fit-content",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={image.fileUrl}
                        style={{ height: "14vh" }}
                        className="uploadImage"
                      />
                    </a>
                  </>
                ) : (
                  <div style={{ height: "14vh" }}>
                    {" "}
                    <NoImageFoundDocument border={"none"} />
                  </div>
                )
              )}
            </Carousel>

            {/* <img src={props.data.fileUrl} className="uploadImage" /> */}
            {/* </a> */}
            <div
              className="row unionRowUploadImage"
              style={{ direction: "rtl" }}
            >
              <div
                className="col-12 cont"
                style={{ color: "#fff" }}
                ref={reference}
              >
                <p className={classText ? classText : "paraghramImageUnion"}>
                  <span
                    ref={spanRef}
                    contentEditable
                    suppressContentEditableWarning
                    onInput={() =>
                      setTextWidth(getTextWidthInPixels(spanRef.current!))
                    }
                  >
                    {" تجمیعی "}
                    {props.accumulative.accumulativeAmount.toLocaleString()}
                    {" ریال "}
                  </span>
                </p>
              </div>
            </div>
          </>
        </div>
      ) : (
        <NoImageFoundDocument />
      )}
    </>
  );
}
